import { createContext } from "preact";
import { Boat } from "./services/requests";

export const BoatContext = createContext<Boat | null>(null);
